export type AppLocalisationCode = "IN" | "AE" | "OTHER";

export type AppLocalisation = {
  code: AppLocalisationCode;
  brokerCountry: string;
  currencySymbol: string;
  numberLocale: string;
  taxLabel: "GST" | "VAT";
  taxRatePercent: number;
  hasStateSplit: boolean;
  taxIdLabel: string;
};

const LOCALISATIONS: Record<"IN" | "AE", AppLocalisation> = {
  IN: {
    code: "IN",
    brokerCountry: "India",
    currencySymbol: "₹",
    numberLocale: "en-IN",
    taxLabel: "GST",
    taxRatePercent: 18,
    hasStateSplit: true,
    taxIdLabel: "GSTIN",
  },
  AE: {
    code: "AE",
    brokerCountry: "United Arab Emirates",
    currencySymbol: "AED",
    numberLocale: "en-AE",
    taxLabel: "VAT",
    taxRatePercent: 5,
    hasStateSplit: false,
    taxIdLabel: "TRN",
  },
};

const CODE_BY_ENV_VALUE: Record<string, "IN" | "AE"> = {
  IN: "IN",
  IND: "IN",
  INDIA: "IN",
  AE: "AE",
  UAE: "AE",
  "UNITED ARAB EMIRATES": "AE",
};

const buildFallbackLocalisation = (country: string): AppLocalisation => ({
  code: "OTHER",
  brokerCountry: country,
  currencySymbol: "$",
  numberLocale: "en-US",
  taxLabel: "VAT",
  taxRatePercent: 5,
  hasStateSplit: false,
  taxIdLabel: "Tax ID",
});

function resolveLocalisation(): AppLocalisation {
  const rawValue = import.meta.env.VITE_APP_LOCALISATION_COUNTRY?.trim() || "";
  if (!rawValue) return LOCALISATIONS.IN;

  const code = CODE_BY_ENV_VALUE[rawValue.toUpperCase()];

  return code ? LOCALISATIONS[code] : buildFallbackLocalisation(rawValue);
}

export const APP_LOCALISATION = resolveLocalisation();

export const CURRENCY_SYMBOL = APP_LOCALISATION.currencySymbol;

export const NUMBER_LOCALE = APP_LOCALISATION.numberLocale;
